export default __webpack_public_path__ + "static/WORK-2966c31db034ebb57300d2130fe1e3be.jpg";